<div class="main-content incidencia-create-page">
  <div class="container-fluid">
    <section class="incidencia-create-page__hero">
      <div class="incidencia-create-page__hero-copy">
        <div class="incidencia-create-page__hero-icon">
          <span class="material-icons">bug_report</span>
        </div>

        <div>
          <p class="incidencia-create-page__eyebrow">Incidencias QA</p>
          <h1>Alta de incidencia</h1>
          <p>Captura el detalle del defecto y agrega evidencia para documentarlo desde el inicio.</p>
        </div>
      </div>

      <div class="incidencia-create-page__hero-meta">
        <div class="incidencia-create-page__hero-tags">
          <span class="incidencia-create-page__chip" *ngIf="proyectoNombre">
            <span class="material-icons">folder_open</span>
            Proyecto: <strong>{{ proyectoNombre }}</strong>
          </span>
          <span class="incidencia-create-page__chip" *ngIf="etapaNombre">
            <span class="material-icons">flag</span>
            Etapa: <strong>{{ etapaNombre }}</strong>
          </span>
          <span class="incidencia-create-page__chip incidencia-create-page__chip--status">
            <span class="material-icons">radio_button_checked</span>
            Estatus: <strong>{{ open }}</strong>
          </span>
        </div>

        <div class="incidencia-create-page__hero-actions">
          <button type="button" mat-raised-button class="btn app-form-btn app-form-btn--secondary" (click)="onNoClick()">
            Cancelar
          </button>

          <button type="button" mat-raised-button class="btn app-form-btn app-form-btn--primary" (click)="onSave()">
            Guardar incidencia
          </button>
        </div>
      </div>
    </section>

    <section class="incidencia-create-page__layout">
      <div class="incidencia-create-page__main">
        <section class="incidencia-create-page__card">
          <div class="incidencia-create-page__card-header">
            <div class="incidencia-create-page__card-title">
              <span class="material-icons">edit_note</span>
              <div>
                <h2>Información de la incidencia</h2>
                <p>Define el defecto con el nivel de detalle suficiente para que pueda ser atendido sin ambigüedad.</p>
              </div>
            </div>
          </div>

          <form class="incidencia-create-page__form" [formGroup]="formRegistro">
            <div class="incidencia-create-page__form-grid">
              <mat-form-field appearance="outline" class="incidencia-create-page__field incidencia-create-page__field--wide">
                <mat-label>Título</mat-label>
                <input matInput aria-label="Título" type="text" formControlName="titulo" maxlength="150" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="incidencia-create-page__field incidencia-create-page__field--version">
                <mat-label>Versión</mat-label>
                <mat-select formControlName="version">
                  <mat-option *ngFor="let opcion of opcionesVersion" [value]="opcion.id">
                    {{ opcion.etiqueta }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="incidencia-create-page__field incidencia-create-page__field--compact">
                <mat-label>Prioridad</mat-label>
                <mat-select formControlName="prioridad">
                  <mat-option *ngFor="let prioridad of listaprioridad" [value]="prioridad.nombre">
                    {{ prioridad.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="incidencia-create-page__field incidencia-create-page__field--compact">
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="tipo">
                  <mat-option *ngFor="let tipo of listaTipo" [value]="tipo.tipo">
                    {{ tipo.tipo }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="incidencia-create-page__field incidencia-create-page__field--full">
                <mat-label>Descripción</mat-label>
                <textarea matInput aria-label="Descripción" formControlName="descripcion" rows="10" maxlength="2000"></textarea>
              </mat-form-field>
            </div>
          </form>
        </section>
      </div>

      <aside class="incidencia-create-page__aside">
        <section class="incidencia-create-page__card incidencia-create-page__card--summary">
          <div class="incidencia-create-page__card-header">
            <div class="incidencia-create-page__card-title">
              <span class="material-icons">insights</span>
              <div>
                <h2>Contexto de captura</h2>
                <p>Confirma el alcance antes de registrar la incidencia.</p>
              </div>
            </div>
          </div>

          <div class="incidencia-create-page__summary-list">
            <div class="incidencia-create-page__summary-item">
              <span class="incidencia-create-page__summary-label">Proyecto</span>
              <strong>{{ proyectoNombre || 'Sin proyecto' }}</strong>
            </div>

            <div class="incidencia-create-page__summary-item">
              <span class="incidencia-create-page__summary-label">Etapa</span>
              <strong>{{ etapaNombre || 'Sin etapa' }}</strong>
            </div>

            <div class="incidencia-create-page__summary-item">
              <span class="incidencia-create-page__summary-label">Estado inicial</span>
              <strong>{{ open }}</strong>
            </div>

            <div class="incidencia-create-page__summary-item">
              <span class="incidencia-create-page__summary-label">Evidencias cargadas</span>
              <strong>{{ evidencia.length }}</strong>
            </div>
          </div>
        </section>

        <section class="incidencia-create-page__card">
          <div class="incidencia-create-page__card-header">
            <div class="incidencia-create-page__card-title">
              <span class="material-icons">attach_file</span>
              <div>
                <h2>Evidencias</h2>
                <p>Agrega archivos de soporte para documentar la incidencia desde este registro.</p>
              </div>
            </div>
          </div>

          <div class="incidencia-create-page__evidencia-actions">
            <button
              type="button"
              mat-raised-button
              class="btn app-form-btn app-form-btn--primary app-form-btn--compact incidencia-create-page__upload-btn"
              [disabled]="btnAgrega">
              Agregar archivo
              <input
                type="file"
                id="nameFile"
                aria-label="Agregar archivo"
                accept="image/*, application/*,file_extension|audio/*|video/mp4,video/*|image/*|media_type"
                mozdirectory
                directory
                multiple
                (change)="subirEv()"
              />
            </button>

              <button
              type="button"
              mat-raised-button
              class="btn app-form-btn app-form-btn--secondary app-form-btn--compact"
              [disabled]="btnElimina"
              (click)="elimina()">
              Quitar selección
            </button>
          </div>

          <div class="incidencia-create-page__evidencia-panel" *ngIf="evidencia.length > 0; else evidenciaVacia">
            <mat-selection-list
              class="incidencia-create-page__evidencia-list"
              [ngModel]="selectedOptions"
              (ngModelChange)="onNgModelChange($event)"
              [ngModelOptions]="{ standalone: true }">
              <mat-list-option *ngFor="let item of evidencia" [value]="item">
                {{ item.name }}
              </mat-list-option>
            </mat-selection-list>
          </div>

          <ng-template #evidenciaVacia>
            <div class="incidencia-create-page__empty-state">
              <span class="material-icons">perm_media</span>
              <strong>Sin evidencias agregadas</strong>
              <p>Adjunta imágenes, videos o documentos que ayuden a entender el defecto reportado.</p>
            </div>
          </ng-template>
        </section>
      </aside>
    </section>

  </div>
</div>
